import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Button } from '@app/core';
import { QuoteInformation } from 'queries';

interface Props {
  disabled: boolean;
}

export const QuoteSetupActions = ({ disabled }: Props) => {
  const { t } = useTranslation();
  const { isSubmitting, submitForm } =
    useFormikContext<Partial<QuoteInformation>>();

  return (
    <Button
      color="green"
      onClick={submitForm}
      isLoading={isSubmitting}
      disabled={disabled}
    >
      {t('quote.create.submit')}
    </Button>
  );
};
